import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { CustomButton } from 'src/components/CustomButton';
import { PersonaDetailsPanel } from 'src/components/PersonaDetailsPanel';
import { useStyles } from './useStyles';

export const PersonaTooltipContent = ({ className, persona, onSavePersona, disabled }) => {
  const styles = useStyles();

  return (
    <PersonaDetailsPanel
      className={cx(styles.root, className)}
      persona={persona}
      customActionsSlot={
        persona?.isSuggested &&
        onSavePersona && (
          <CustomButton
            className={styles.button}
            onClick={() => onSavePersona(persona)}
            disabled={disabled}
            variant="contained"
            color="primary"
          >
            Save audience
          </CustomButton>
        )
      }
    />
  );
};

PersonaTooltipContent.displayName = 'PersonaTooltipContent';

PersonaTooltipContent.propTypes = {
  className: PropTypes.string,
  persona: PropTypes.shape({
    isSuggested: PropTypes.bool,
  }).isRequired,
  onSavePersona: PropTypes.func,
  disabled: PropTypes.bool,
};

PersonaTooltipContent.defaultProps = {
  className: null,
  onSavePersona: null,
  disabled: false,
};
